import { TooltipButton } from '../tooltip-button/tooltip-button';

import * as S from './culture-compass.styles';

export type Props = {
  industryAngle: number;
  profileAngle: number;
};

type ProfileHandProps = {
  profileAngle: number;
};

const ProfileHand: React.FC<ProfileHandProps> = ({ profileAngle }) => (
  <S.ProfileHandOuterWrapper $profileAngle={profileAngle}>
    <S.ProfileHandInnerWrapper>
      <S.ProfileHand aria-hidden />
    </S.ProfileHandInnerWrapper>
  </S.ProfileHandOuterWrapper>
);

type IndustryHandProps = {
  industryAngle: number;
};

const IndustryHand: React.FC<IndustryHandProps> = ({ industryAngle }) => (
  <S.IndustryHandOuterWrapper $industryAngle={industryAngle}>
    <S.IndustryHandInnerWrapper>
      <S.IndustryHand aria-hidden />
    </S.IndustryHandInnerWrapper>
  </S.IndustryHandOuterWrapper>
);

export const CultureCompass: React.FC<Props> = ({
  industryAngle,
  profileAngle,
}) => {
  return (
    <S.Container>
      <S.CompassWrapper>
        <S.Background aria-hidden />

        <IndustryHand industryAngle={industryAngle} />

        <ProfileHand profileAngle={profileAngle} />

        <S.OriginWrapper>
          <S.Origin />
        </S.OriginWrapper>
      </S.CompassWrapper>

      <S.LegendContainer>
        <TooltipButton
          messageId="JOBS_JOB_DETAILS_COMPANY_CULTURE_COMPASS_LEGEND_LEFT"
          helperText="CAREER_GUIDANCE_DETAILS_PAGE_TRADITIONAL_1"
        />

        <TooltipButton
          messageId="JOBS_JOB_DETAILS_COMPANY_CULTURE_COMPASS_LEGEND_RIGHT"
          helperText="CAREER_GUIDANCE_DETAILS_PAGE_MODERN_1"
        />
      </S.LegendContainer>
    </S.Container>
  );
};
